// English translation

const en = {
  "menu.hotel_frontdesk": "FRONTDESK",
  "hotel.frontdesk": "Frontdesk",
  "hotel.frontdesk.summary": "Rooms Summary",
  "hotel.frontdesk.guests": "Guests",
  "hotel.frontdesk.end_day": "End Day",
  "hotel.frontdesk.previous_day": "Previous Day",
  "hotel.frontdesk.pending": "Pending",
  "hotel.guests_list.report": "Guests List",
  "hotel.guests_list.filter": "Filter",
  "hotel.guests_list.date": "Date",
  "hotel.guests_list.operation_center": "Operation Center",
  "hotel.guests_list.only_main_guest": "Only Main Guest",
  "hotel.rooms_occupancy.report": "Rooms Occupancy",
  "hotel.rooms_occupancy.filter": "Filter",
  "hotel.rooms_occupancy.date": "Date",
  "hotel.rooms_occupancy.operation_center": "Operation Center",
  "hotel.rooms_occupancy.only_main_guest": "Only Main Guest",
  "hotel.folio.add_night.msg_start":
    "Are you sure you would like to add a night?",
  "hotel.folio.add_night": "Add Night",
  "hotel.folio.add_night.msg_success": "Night added successfully",
  "hotel.folio.update": "Update",
  "hotel.folio.add_payment": "Add Payment",
  "hotel.folio.update.arrival_date": "Arrival Date",
  "hotel.folio.update.departure_date": "Departure Date",
  "hotel.folio.update.unit_price": "Unit Price",
  "hotel.folio.update.overbooking": "Overbooking",
  "hotel.folio.update.product": "Accommodation",
  "hotel.folio.update.room": "Room",
  "hotel.folio.guest.main_guest": "Main Guest?",
  "hotel.folio.guest.name": "Name",
  "hotel.folio.guest.mobile": "Mobile",
  "hotel.folio.guest.email": "Email",
  "hotel.folio.guest.address": "Address",
  "hotel.folio.guest.nationality": "Nationality",
  "hotel.folio.guest.country_residence": "Country of Residence",
  "hotel.folio.guest.sex": "Sex",
  "hotel.folio.guest.type_guest": "Type of Guest",
  "hotel.folio.guest.id_number": "ID Number",
  "hotel.folio.guest.type_document": "Type of Document",
  "hotel.folio.guest.birthday": "Birthday",
  "hotel.folio.guest.profession": "Profession",
  "hotel.folio.guest.folio": "Folio",
  "hotel.folio.party_holder": "Customer",
  "hotel.folio.comments": "Comments",
  "hotel.housekeeping.operation_center": "Operation Center",
  "hotel.housekeeping.employee": "Employee",
  "hotel.housekeeping.date": "Date",
  "hotel.print_housekeeping.report": "Housekeeping Report",
  "hotel.housekeeping.grouped_by_employee": "Grouped by Employee",
  "hotel.guests_list.show_guests": "Show Guests",
  "hotel.operation_forecast.report": "Operation Forecast",
  "hotel.operation_forecast.fiscalyear": "Fiscal Year",
  "hotel.operation_forecast.operation_center": "Operation Center",
  "hotel.operation_forecast.period":"Period"

};

export default en;
